<script setup>

import WhyUsBloc from "@/components/WhyUsBloc.vue";
import {defineProps} from "vue";
const props = defineProps({aboutBloc:[], aboutTitle:{type:String,value:""}});
</script>

<template>
  <!-- WHY CHOOSE US? -->
  <div class="uk-padding-large uk-padding-remove-horizontal uk-position-relative bg-img3 impx-features">
    <div class="uk-container">

      <div
          class="uk-width-3-4@xl uk-width-3-4@l uk-width-1-1@m uk-width-1-1@s uk-margin-medium-top uk-position-relative uk-height-1-1 impx-features-content"
          data-uk-grid>

        <!-- Intro Text -->
        <div class="impx-intro uk-text-left">
          <h2 class="uk-margin-remove-bottom uk-margin-small-top">{{props.aboutTitle}}</h2>
          <!--          <p class="uk-margin-remove uk-text-uppercase">You can additional subtitle Here.</p>-->
        </div>
        <!-- Intro Text End -->
        <ul class="uk-child-width-1-3@xl uk-child-width-1-3@l uk-child-width-1-3@m uk-child-width-1-2@s impx-features-hl uk-grid-medium uk-grid-match uk-margin-top impx-margin-top-small"
            data-uk-grid>
          <why-us-bloc
              v-for="(about, index) in props.aboutBloc"
              :key="index"
              color="color4" bg-icon="'icon: users; ratio: 8'"
                       :desc="about?.content"
                       :title="about?.title"/>
<!--          -->
<!--          <why-us-bloc bg-icon="'icon: bell; ratio: 8'" color="color2"-->
<!--                       desc="'En choisissant cité sainte augustine, vous économiser  de l'argent tout en bénéficiant de la qualité de nos services.'"-->
<!--                       title="'Service prioritaire'"/>-->
<!--          <why-us-bloc bg-icon="'icon: star; ratio: 8'" color="color3"-->
<!--                       desc="'Nous mettons à votre disposition un Wifi Haut debit, un Parking, une Salle de fitness, une piscine, Restaurant et bar sur place.'"-->
<!--                       title="'Meilleur commodité'"/>-->
<!--          <why-us-bloc bg-icon="'icon: heart; ratio: 8'" color="color4"-->
<!--                       desc="'Nous vous écoutons et nous apportons constamment des améliorations pour répondre à vos besoins.'"-->
<!--                       title="'Magnifique paronama'"/>-->
<!--          <why-us-bloc bg-icon="'icon: image; ratio: 8'" color="color5"-->
<!--                       desc="'Une vue exceptionnellement belle et étendue sur la belle de Yamoussoukro, caractérisée par une diversité d'éléments visuels harmonieusement agencés.'"-->
<!--                       title="'Garantie de satisfaction'"/>-->
<!--          <why-us-bloc bg-icon="'icon: happy; ratio: 8'" color="color6"-->
<!--                       desc="'À la cité sainte augustine, Nous faisons tout pour vous assurer de tirer le meilleur parti de vos séjours dans une joie magique.'"-->
<!--                       title="'Profitez de votre temps'"/>-->
        </ul>

      </div>

    </div>
  </div>
  <!-- WHY CHOOSE US? END -->
</template>

<style scoped>

</style>